<template>
  <VLayout :title="$t('categories.title')">
    <vue-element-loading :active="loading_groupedCategories" />
    <b-container fluid class="p-0" v-if="categories">
      <b-row class="d-flex justify-content-between">
        <b-col
          class="category p-3"
          v-for="(groupedcategory, index) in categories"
          :key="index"
          cols="12"
          md="3"
        >
          <router-link :to="{name: 'grouped_categories_products', query:{'groupedCategory': groupedcategory.uuid}}" class="router-category">
            <b-card footer-tag="footer" class="clickable homecard bd-highlight">
              <div class="imgcontainer mb-0">
                <PictureFallback
                  :src="groupedcategory.image"
                  :alt="$tradukojTranslate(groupedcategory.name)"
                  class="card-img"
                />
              </div>
              <p
                class="text-center align-middle m-0 card-text text-uppercase"
                slot="footer"
                v-if="groupedcategory.name"
              >{{ $tradukojTranslate(groupedcategory.name) }}</p>
            </b-card>
          </router-link>
        </b-col>
      </b-row>
      <b-row>
        <b-col>
          <Pagination
            v-if="perPage < total"
            :total="total"
            :perPage="perPage"
            v-model="currentPage"
            @input="onPageChange"
            class="justify-content-center"
          />
        </b-col>
      </b-row>
    </b-container>
    <div v-else>
      {{ $t("categories.no_results") }}
    </div>
  </VLayout>
</template>

<script>
import VLayout from "@/layouts/Default";
import Pagination from "@/components/Pagination";
import PictureFallback from "@/components/PictureFallback";
import { mapState } from "vuex";

export default {
  components: {
    VLayout,
    Pagination,
    PictureFallback,
  },
  data() {
    return {
      categories: undefined,
      total: 0,
      perPage: 24,
      currentPage: 1,
      loading_groupedCategories: false,
    };
  },
  watch: {
    $route() {
      this.reload();
    },
  },
  created() {
    this.reload();
  },
  computed: {
    ...mapState({
      active_lang: state => state.i18nmap.active_lang,
    }),
  },
  methods: {
    reload() {
      this.loadCategories();
    },
    loadCategories() {
      window.scrollTo(0, 0);

      this.loading_groupedCategories = true;

      this.$store
        .dispatch("drugs/REQUEST_PHDRUGS_GROUPED_CATEGORIES_LIST", {
          langtag: this.active_lang.langtag,
          per_page: this.perPage,
          current_page: this.currentPage,
        }).then(
          response => {
            if (response.data.results.length > 0)
            {
              this.categories = response.data.results;
              this.total = response.data.count;
              this.loading_groupedCategories = false;
            }
          },
          err => {
            this.$sentry({ capture: err });
            this.$router.push({ name: "fallback-error-page" });
            this.loading_groupedCategories = false;
          }
        );
    },
    onPageChange () {
      this.loadCategories();
    },
  },
  fallbackI18n: {
    messages: {
      und: {
        categories: {
          title: "Categories",
          no_results: "No results found",
        },
      },
    },
  },
};
</script>
<style lang="scss" scoped>
.card-body {
  overflow: hidden;
  padding: 0rem;
}
.card-img{
  max-width: 100%;
  object-fit: cover;
  transition: all 0.3s;
}
.card-img:hover {
  transform: scale(1.1);/* (150% zoom - Note: if the zoom is too large, it will go outside of the viewport) */
}
.card-text{
  text-decoration: none;
  color: $corp-color1;
}
.card-footer{
  background-color: $gray-200;
}
.router-category{
  text-decoration: none;
}
</style>

